import { authorizedRequestJson } from '../lib/authSession';

function buildQuery({ statuses, types, accountId } = {}) {
  const params = new URLSearchParams();

  (statuses ?? []).filter(Boolean).forEach((status) => params.append('status', status));
  (types ?? []).filter(Boolean).forEach((type) => params.append('type', type));

  if (accountId?.trim()) {
    params.set('accountId', accountId.trim());
  }

  const query = params.toString();
  return query ? `?${query}` : '';
}

export function listAdminOrders({ statuses, types, accountId } = {}) {
  return authorizedRequestJson(`/admin/orders${buildQuery({ statuses, types, accountId })}`);
}

export function getAdminOrder({ orderId }) {
  return authorizedRequestJson(`/admin/orders/${encodeURIComponent(orderId)}`);
}

export function updateAdminOrderStatus({ orderId, status }) {
  return authorizedRequestJson(`/admin/orders/${encodeURIComponent(orderId)}/status`, {
    method: 'PATCH',
    body: { status },
  });
}

export function addAdminOrderNote({ orderId, message }) {
  return authorizedRequestJson(`/admin/orders/${encodeURIComponent(orderId)}/notes`, {
    method: 'POST',
    body: { message },
  });
}

export function getAdminOrderArtifactViewUrl({ orderId, memberId, documentId }) {
  return authorizedRequestJson(
    `/admin/orders/${encodeURIComponent(orderId)}/artifacts/${encodeURIComponent(memberId)}/${encodeURIComponent(documentId)}/view-url`
  );
}

export function getAdminPrintPackageViewUrl({ orderId }) {
  return authorizedRequestJson(`/admin/orders/${encodeURIComponent(orderId)}/package-view-url`);
}
